
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Swiftdzireonrentinpune() {



  const cardData =
  {
    keyword: ' Swift Dzire On Rent in Pune',
    heading: 'Vaishnavi Travels: Swift Dzire On Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers reliable and affordable Swift Dzire on Rent in Pune, ideal for local travel, airport transfers, business trips, family outings, and outstation journeys. Our Swift Dzire cars are well-maintained with comfortable seating, air-conditioning, and ample luggage space, ensuring a smooth and enjoyable ride for every passenger. With professional chauffeurs, punctual service, and flexible booking options, we make travel convenient and stress-free. Whether it’s a daily commute, wedding function, or long-distance trip, Vaishnavi Travels guarantees safe, comfortable, and budget-friendly Swift Dzire rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s grand fort palace and one of the city’s most iconic landmarks. Once the political seat of the Maratha Empire, its mighty gates, gardens, and ancient ruins narrate stories of power and valor. Though destroyed partially by fire in 1828, the fort still attracts thousands daily. The evening light-and-sound show revives tales of Bajirao and Mastani with grandeur. Its courtyards, fountains, and corridors are filled with historic charm. Shaniwar Wada is Pune’s timeless cultural crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a monument of national importance tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, the palace serves as a museum housing Gandhi’s personal belongings, photos, and letters. Its sprawling gardens and Italian arches add serene charm. Students, historians, and tourists visit to pay homage to the Father of the Nation. Aga Khan Palace is Pune’s inspirational symbol of sacrifice and heritage."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Perched on a hill, it offers panoramic views of the Sahyadris and thrilling trekking routes. Visitors explore its bastions, memorials, and temples that echo Maratha bravery. During monsoon, misty weather and waterfalls make the experience enchanting. Local stalls serve rustic pithla-bhakri to trekkers and pilgrims. Sinhagad Fort is Pune’s blend of history, adventure, and scenic charm."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established more than 125 years ago, it houses a grand idol adorned with gold and ornaments. During Ganesh Chaturthi, it becomes the epicenter of massive celebrations attracting lakhs of devotees. Known for its charitable and cultural contributions, it is a hub of devotion and service. The temple’s aura is spiritually uplifting for all visitors. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, sanctum chambers, and a Nandi mandapa, it reflects India’s ancient craftsmanship. Despite being in the city center, it provides peace and a meditative atmosphere. Evening chants create an aura of devotion. History lovers admire its simplicity and timeless design. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing more than 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include musical instruments, ornaments, sculptures, and everyday antiques from across India. A highlight is the recreated Mastani Mahal, symbolizing Maratha romance and heritage. Students and tourists find it highly educational and fascinating. It preserves centuries of Indian artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of art and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum enrich the visit. Pilgrims climb 103 steps to reach the temple, blending devotion with scenic beauty. Sunrise and sunset views here are captivating. Parvati Hill is Pune’s sacred and serene retreat above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center of wellness and spirituality. Spread across lush gardens, it attracts seekers and tourists from around the world. Meditation sessions, yoga practices, and workshops on personal growth are held daily. Its Zen gardens and tranquil meditation halls create a peaceful experience. Beyond spirituality, it offers rejuvenation and relaxation for modern lifestyles. Osho Ashram is Pune’s international hub of mindfulness and healing."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, photography, and peaceful walks here. The garden also symbolizes Indo-Japanese cultural friendship. Its year-round greenery makes it a favorite among nature lovers. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular outskirt retreat near Pune. It supplies water to the city while offering scenic backdrops of hills and flowing waters. Monsoon transforms the dam into a spectacular sight with overflowing water. Families enjoy roadside snacks like roasted corn and tea while relaxing by the banks. It also serves as the starting point for Sinhagad Fort trips. Khadakwasla Dam is Pune’s refreshing natural escape."
  }
],


      "services": [
    {
      "name": "Pune Swift Dzire Rental",
      "description": "Rent a Swift Dzire in Pune for comfortable and stylish city travel or short trips. This popular sedan offers smooth handling, fuel efficiency, and a spacious cabin, making it perfect for daily commuting, airport transfers, or casual outings. With well-maintained vehicles and professional drivers, your ride is guaranteed to be hassle-free and punctual."
    },
    {
      "name": "Swift Dzire Car Hire Pune",
      "description": "Hire a Swift Dzire car in Pune for both personal and corporate use. Ideal for solo travelers, couples, and small families, this sedan combines elegance with practicality. Features include air conditioning, ample boot space, and ergonomic seating. Drivers are courteous and knowledgeable about Pune’s routes, ensuring timely pickups and drop-offs."
    },
    {
      "name": "Sedan Dzire on Rent Pune",
      "description": "Avail sedan Dzire on rent in Pune for city rides, office commutes, or weekend outings. This car offers a smooth ride with advanced suspension and quiet interiors for a peaceful journey. Equipped with essential amenities, it suits both short and medium-distance travel with comfort and safety."
    },
    {
      "name": "AC Swift Dzire Hire",
      "description": "Experience travel in cool comfort with our air-conditioned Swift Dzire hire service in Pune. The efficient AC system ensures a pleasant environment irrespective of weather conditions. Perfect for corporate clients, airport pickups, and family trips, this sedan promises a refreshing ride throughout your journey."
    },
    {
      "name": "Non AC Dzire Car Rental",
      "description": "For budget-conscious travelers, our non-AC Swift Dzire rental offers a cost-effective solution without compromising on space or safety. Ideal for shorter trips within the city or nearby suburbs where AC may not be necessary. Enjoy a clean, well-maintained vehicle with professional driver service."
    },
    {
      "name": "Wedding Swift Dzire Rental",
      "description": "Make your special day flawless with our Swift Dzire rental tailored for weddings. This elegant sedan serves as an excellent car for the bride, groom, or close family members. Decor options are available to match your wedding theme, and our punctual drivers ensure timely arrivals at all wedding venues."
    },
    {
      "name": "Airport Transfer Swift Dzire",
      "description": "Reliable and timely airport transfer services using Swift Dzire in Pune. Our drivers monitor flight timings for smooth pickups and drop-offs, helping you avoid delays or waiting times. Comfortable seating and luggage space accommodate your belongings with ease for stress-free airport journeys."
    },
    {
      "name": "Corporate Swift Dzire Service",
      "description": "Enhance your corporate travel experience with our Swift Dzire sedan rentals, designed for business meetings, client visits, and office commutes. Professional drivers ensure timely pickups, and the vehicle interiors provide a quiet, comfortable space to work or relax between appointments."
    },
    {
      "name": "Outstation Swift Dzire Pune",
      "description": "Plan your outstation trips from Pune with our Swift Dzire rental service, perfect for solo travelers or couples seeking a reliable and fuel-efficient car for long-distance journeys. The sedan offers good mileage, comfortable seating, and smooth ride quality for intercity travel."
    },
    {
      "name": "One Way Swift Dzire Hire",
      "description": "Book a one-way Swift Dzire hire from Pune for convenient point-to-point travel without the need for round trips. Ideal for airport drops, outstation travel, or quick city transfers, this service offers flexibility and cost-effectiveness with reliable driver support."
    },
    {
      "name": "Dzire with Driver Pune",
      "description": "Rent a Swift Dzire with a professional driver in Pune for a safe and stress-free travel experience. Drivers are trained for city and highway navigation, courteous behavior, and customer service excellence. Perfect for business, leisure, or family travel."
    },
    {
      "name": "Budget Sedan Dzire Rental",
      "description": "Affordable sedan Dzire rental options in Pune designed for budget travelers who seek comfort and reliability without extra costs. Ideal for students, small families, or short city rides, these vehicles are regularly serviced and paired with trustworthy drivers."
    },
    {
      "name": "Book Swift Dzire Online Pune",
      "description": "Easily book your Swift Dzire rental online in Pune with instant confirmation, transparent pricing, and customizable options. Choose your dates, trip type, and add-ons such as driver preferences or pick-up locations. Enjoy hassle-free booking with customer support available around the clock."
    }
  ],
  "tableData": [
    ["Pune Swift Dzire Rental", "Swift Dzire Car Hire Pune"],
    ["Sedan Dzire on Rent Pune", "AC Swift Dzire Hire"],
    ["Non AC Dzire Car Rental", "Wedding Swift Dzire Rental"],
    ["Airport Transfer Swift Dzire", "Corporate Swift Dzire Service"],
    ["Outstation Swift Dzire Pune", "One Way Swift Dzire Hire"],
    ["Dzire with Driver Pune", "Budget Sedan Dzire Rental"],
    ["Book Swift Dzire Online Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Swift Dzire On Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers Swift Dzire on rent in Pune for local, airport, and outstation travel — ideal for individuals, small families, and business trips."
  },
  {
    "WhyChooseheading": "Comfortable and Fuel-Efficient Sedan",
    "WhyChoosedescription": "Swift Dzire is known for its comfortable seating, smooth ride, and excellent mileage — making it perfect for short or long journeys."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Cars",
    "WhyChoosedescription": "Our Swift Dzire fleet is regularly serviced and cleaned to ensure safety, hygiene, and performance on every trip."
  },
  {
    "WhyChooseheading": "Professional and Polite Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide timely pickups, smooth driving, and courteous service throughout your journey."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Available for hourly, daily, and outstation rentals, our Swift Dzire cars are suitable for every kind of travel need."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer clear, all-inclusive pricing with no hidden charges — fuel, driver, toll, and taxes covered."
  },
  {
    "WhyChooseheading": "Ideal for Airport Transfers, Office Commute, and City Tours",
    "WhyChoosedescription": "Swift Dzire rentals are perfect for professional meetings, sightseeing in Pune, or airport drop/pickup."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Booking",
    "WhyChoosedescription": "Our support team is always available to help with bookings, changes, or queries for a hassle-free experience."
  }
]



















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer Swift Dzire on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels offers Swift Dzire cars on rent in Pune for local and outstation travel. It’s a great choice for solo travelers, couples, or small families looking for a comfortable sedan ride.',
    },
    {
      question: 'What features does the Swift Dzire rental from Vaishnavi Travels include?',
      answer: 'The Swift Dzire comes with air-conditioning, power steering, comfortable seating, decent boot space, and a fuel-efficient engine—ideal for both city and highway travel.',
    },
    {
      question: 'Is the Swift Dzire well-maintained and driven by a professional driver?',
      answer: 'Absolutely! All Swift Dzire cars are regularly serviced and maintained in top condition. Rentals come with experienced, courteous drivers for a safe and smooth journey.',
    },
    {
      question: 'What is the rental cost for Swift Dzire in Pune?',
      answer: 'Rental rates for Swift Dzire in Pune typically start from ₹1,800 for a local half-day trip. Charges may vary based on distance, duration, and whether the trip is local or outstation.',
    },
    {
      question: 'Can I book a Swift Dzire for outstation trips from Pune?',
      answer: 'Yes, Swift Dzire is available for both one-way and round-trip outstation journeys from Pune with flexible and transparent pricing.',
    },
    {
      question: 'How early should I book a Swift Dzire rental in Pune?',
      answer: 'It is advisable to book at least 1-2 days in advance, especially during weekends or holiday seasons, to ensure availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available for Swift Dzire rentals in Pune?',
      answer: 'Yes, Vaishnavi Travels offers flexible pickup and drop points within Pune and surrounding areas for your convenience.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Aniket Pawar",
    position: "Frequent Traveler",
    feedback:
      "I rented a Swift Dzire from Vaishnavi Travels for a day trip in Pune. The car was clean and the driver was polite and punctual. Very satisfied with the service!",
    rating: 5,
  },
  {
    name: "Ms. Rutuja Jain",
    position: "Working Professional",
    feedback:
      "The Swift Dzire rental from Vaishnavi Travels was perfect for my Pune to Lonavala trip. Comfortable ride and excellent service. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];






































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/swift-dzire-rental-pune.jpg",
  "description": "Rent Swift Dzire cars in Pune with options for AC and Non AC. Perfect for weddings, airport transfers, corporate services, and outstation trips with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "180"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/swift-dzire-rental-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Swift Dzire On Rent in Pune | AC & Non AC Dzire Car Hire</title>
  <meta
    name="description"
    content="Rent Swift Dzire cars in Pune with options for AC and Non AC. Perfect for weddings, airport transfers, corporate services, and outstation trips with experienced drivers."
  />
  <meta
    name="keywords"
    content="Pune Swift Dzire Rental, Swift Dzire Car Hire Pune, Sedan Dzire on Rent Pune, AC Swift Dzire Hire, Non AC Dzire Car Rental, Wedding Swift Dzire Rental, Airport Transfer Swift Dzire, Corporate Swift Dzire Service, Outstation Swift Dzire Pune, One Way Swift Dzire Hire, Dzire with Driver Pune, Budget Sedan Dzire Rental, Book Swift Dzire Online Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinpune;